import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { SharedModule } from 'src/app/demo/shared/shared.module';
import { Subject, takeUntil } from 'rxjs';
import { RTL } from 'src/app/@theme/const';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { TranslateService } from '@ngx-translate/core';
import { TabConst } from 'src/app/tabms/tab-consts';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrl: './auto-complete.component.scss'
})
export class AutoCompleteComponent implements OnInit, OnDestroy, OnChanges {
  SearchCtrl = new FormControl();
  currentLang: string;
  @Input() placeholder;
  @Input() searchProperty: string;
  @Input() customStyle: string;
  @Input() customClass
  @Input() size: 'default' | 'compact' | 'xs' = TabConst.DefaultSize; // New input for size control

  // @Input() cascadedFieldName: string;

  @Input() cascadedParameterName?: string | null;
  @Input() cascadedParameterValue?: any;

  // @Input() set selectedId(id: string | null) {
  //   if (id) this.getById(id);
  // }
  @Input() selectedId;
  @Output() selected = new EventEmitter<any>();
  @Input() serviceInstance
  @Input() fetchFlag: 'getAllbyFilter' | 'getalldatabyfilterWithCount' | '' = ''
  @Input() control: FormControl // Form control for validation
  @Input() type: string = '' // Field type for error display
  @Input() excludeId?: string | number | null; // Optional: exclude a specific id/code from options


  private destroy$: Subject<void> = new Subject<void>();
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  get allClasses() {
    return {
      'custom-combo': true,
      'm-t-5': true,
      'rtl': this.currentLang === 'ar',
      'ltr': this.currentLang !== 'ar',
      'mat-form-field-compact': this.size === 'compact',
      'mat-form-field-xs': this.size === 'xs',
      ...this.customClass
    };
  }

  private applyExclusion(arr: any[]): any[] {
    if (!arr) return [];
    if (this.excludeId === null || this.excludeId === undefined) return arr;
    return arr.filter((item: any) => {
      console.log('Excluding item check:', item, this.excludeId);

      if (typeof item === 'string' || typeof item === 'number') {
        return item != this.excludeId;
      }
      const itemId = ('id' in item) ? item.id : (('code' in item) ? item.code : undefined);
      if (itemId === undefined) return true;
      return itemId != this.excludeId;
    });
  }

  private refreshDataViews(): void {
    // Derive originalData from allData and apply exclusion, then reset filteredItems
    this.originalData = this.applyExclusion(this.allData);
    this.filteredItems = this.originalData;
    // Re-apply selected display text if any
    // if (this.selectedId || this.selectedId === 0) this.getById(this.selectedId);
    if (this.selectedId !== null && this.selectedId !== undefined) {
      console.log('Calling getById with:', this.selectedId);
      this.getById(this.selectedId);
    }
  }

  // Show all options and open the panel when the input gains focus/clicked
  showAllOptions(): void {
    if (!this.originalData || this.originalData.length === 0) return;
    this.filteredItems = this.originalData;
    this.autocompleteTrigger?.openPanel();
  }

  constructor(
    private baseService: BaseService,
    private themeLayout: ThemeLayoutService,
    private translate: TranslateService
  ) {
    this.currentLang = this.baseService.getCurrentLanguage();

    this.themeLayout.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir: string) => {
        (dir === RTL) ? this.currentLang = 'ar' : this.currentLang = 'en';
      }
    })

  }

  searchCtrl = new FormControl('');
  filteredItems;
  originalData;
  private allData: any[] = [];
  @Input() set items(_items) {
    if (!_items) return;
    this.allData = _items;
    this.refreshDataViews();
  }

  ngOnChanges(changes: SimpleChanges) {

    // console.log('original data', this.originalData, this.filteredItems);
    // console.log(this.selectedId)
    // console.log('Changes detected:', changes, this.selectedId);
    if (changes['selectedId']) {
      if (this.selectedId === null || this.selectedId === undefined) {
        // console.log('Clearing dropdown values');
        this.selectedId = null
        setTimeout(() => {
          this.searchCtrl.setValue(null);
        }, 0);
      } else {
        // this.getById(this.selectedId);
        if (this.originalData) this.getById(this.selectedId);
        else this.getData();

      }
    }
    else if (changes['cascadedParameterValue']) {
      this.getData();
    }

    if (changes['searchProperty']) {
      // this.searchProperty = changes['searchProperty'].currentValue?.toLowerCase();
      console.log('Search property changed:', this.searchProperty, changes);
      this.searchProperty = changes['searchProperty'].currentValue.toLowerCase();
      if (!this.searchCtrl.value) return
      // if(this.filteredItems && this.filteredItems.length >0) this.searchCtrl.setValue(this.filteredItems[0][this.searchProperty]);
      if (this.filteredItems && this.filteredItems.length > 0) {
        // console.log(this.filteredItems)
        this.getById(this.selectedId)
      }
    }

    if (changes['excludeId']) {
      this.refreshDataViews();
    }

  }

  ngOnInit() {
    this.getData();

    this.searchCtrl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res === null) {
        this.filteredItems = this.originalData;
      }
      else {
        this.filteredItems = this.filter(res);
      }
    });

  }

  ngAfterViewInit() {
    console.log('After view init', this.serviceInstance);
    if (this.serviceInstance) {
      console.log('Broadcast channel initialized for data updates');
      // this.serviceInstance.channel.onmessage = (msg) => {
      //   if (msg.data === 'new-item-added') {
      //     console.log('New item added, refreshing data', msg);
      //     this.getData(); // تعملي reload للبيانات
      //   }
      // }
      this.serviceInstance.messages$.pipe(takeUntil(this.destroy$)).subscribe((message) => {
        // console.log('New item added, refreshing data', message);
        if (message === 'new-item-added') {
          // console.log('New item added, refreshing data', message);
          this.getData();
        }
      });
    }
  }

  private filter(value: string): any[] {
    const filterValue = this.currentLang === 'ar' ? value : String(value)?.toLowerCase();
    if (!filterValue) this.selected.emit(null);
    return this.originalData.filter((item) => this.searchProperty ?
      item[this.searchProperty].toLowerCase().includes(filterValue) :
      item.toLowerCase().includes(filterValue)
    );
  }

  displayName(item: any): string {
    if (!this.searchProperty) return item
    else return item[this.searchProperty];
  }

  onSelect(item: any): void {
    this.selected.emit(item);
    this.searchCtrl.setValue(this.displayName(item));
    this.autocompleteTrigger?.closePanel();
  }
  getById(id) {
    // debugger
    const item = this.originalData.find((el) =>
      typeof el === 'string'
        ? el === id :
        ('id' in el && el.id == id) || ('code' in el && el.code == id));
    if (item) this.searchCtrl.setValue(this.displayName(item));
  }

  getData(): void {
    // debugger
    let params = {};

    if (this.cascadedParameterName) {

      if (this.cascadedParameterValue) {

        let ParVal = "";
        if (typeof this.cascadedParameterValue === 'string') {
          ParVal = this.cascadedParameterValue;
        } else {

          ParVal = this.cascadedParameterValue.id;
        }
        params = { [this.cascadedParameterName]: ParVal }
      }
    }

    if (this.fetchFlag === 'getalldatabyfilterWithCount') {

      this.serviceInstance?.GetalldatabyfilterWithCount(0, 1000, params).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.allData = res.result.items.map(c => c._entitydto);
          this.refreshDataViews();
        }

      })
    }

    else if (this.fetchFlag === 'getAllbyFilter') {
      params = { SkipCount: 0, MaxResultCount: 1000, ...params } // Set a default max result count
      this.serviceInstance.getAllbyFilter(params).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.allData = res.items;
          this.refreshDataViews();
        }
      })
    }

    else {
      this.serviceInstance?.getAll().pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.allData = res.result;
          this.refreshDataViews();
        }

      })
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.serviceInstance.channel.close();
  }
}
